import {
  CHFIcon,
  EURIcon,
  GBPIcon,
  USDIcon,
} from "@app/components/common/icons";
import { Currency } from "@app/types/currencies";

export const CURRENCY_TITLE: Record<Currency, string> = {
  [Currency.CHF]: "CHF",
  [Currency.EUR]: "EUR",
  [Currency.GBP]: "GBP",
  [Currency.USD]: "USD",
};

export const CURRENCY_ICON: Record<Currency, React.FC> = {
  [Currency.CHF]: CHFIcon,
  [Currency.EUR]: EURIcon,
  [Currency.GBP]: GBPIcon,
  [Currency.USD]: USDIcon,
};
